import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  Card,
  CardHeader,
  Button,
  ListGroup,
  ListGroupItem,
  Container,
  Col,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormInput,
  FormSelect,
  FormGroup,
  CardBody
} from "shards-react";
import {
  doc,
  getDoc,
  updateDoc,
  where,
  documentId,
  getDocs,
  query,
  collection
} from "firebase/firestore";
import { app, db } from "../../../firebase";
import axios from "axios";
import "../../admin/userDetails/tab.css";
import TrainingResult from "../../admin/userDetails/TrainingResult";
import Calibration from "../../admin/userDetails/Calibration";
import DatePicker from "react-datepicker";
import { useAuth } from "../../../providers/AuthProvider";
import moment from "moment";
import VergenceTestsGrid from "../../admin/userDetails/VergenceTestsGrid";
import FullFeaturedCrudGrid from "../../admin/userDetails/FullFeatureGrid";
import { Box } from "@mui/material";
import ProprietaryTestsGrid from "../../admin/userDetails/ProprietaryTestsGrid";
import { getFunctions, httpsCallable } from "firebase/functions";

const StudentDetails = () => {
  const { id } = useParams();
  const { currentUser } = useAuth();
  const history = useHistory();
  const [user, setUser] = useState("");
  const [studentIds, setStudentIds] = useState([]);
  const [guardian, setGuardian] = useState("");
  const [userAuthData, setUserAuthData] = useState("");
  const [toggleState, setToggleState] = useState(1);
  const [otherDetailsEdit, setOtherDetailsEdit] = useState(false);
  const [userDetailsEdit, setUserDetailsEdit] = useState(false);
  const [MovementSpeed, setMovementSpeed] = useState("");
  const [PersonalOffset, setPersonalOffset] = useState("");
  const [ReadCalibrationFromBackend, setReadCalibrationFromBackend] = useState(
    false
  );
  const [offsetValue, setOffsetValue] = useState(null);
  const [pendlumLength, setPendlumLength] = useState(null);
  const [RecommendedSessionsPerWeek, setRecommendedSessionsPerWeek] = useState(
    ""
  );
  const [vrOffset, setVROffset] = useState("");
  // const [activeInactive, setActiveInactive] = useState("");
  const [MobileNumber, setMobileNumber] = useState("");
  const [Age, setAge] = useState("");
  const [ValidTill, setValidTill] = useState(new Date());
  const [answerData, setAnswerData] = useState([]);
  const [readingTestsScores, setReadingTestsScores] = useState([]);
  const [readingSpeedData, setReadingSpeedData] = useState([]);
  const [answer_modal_visible, setAnswerModalVisible] = useState(false);
  const [answer_modal_data, setAnswerModalData] = useState(null);
  let intialDeviceState = {
    manufacturer: "",
    model: "",
    os: "",
    osversion: "",
    version: ""
  };
  const [deviceData, setDeviceData] = useState(intialDeviceState);
  const [vergenceData, setVergenceData] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const cloudFunctions = getFunctions(app, "europe-west3");
  const BASE_URL = process.env;
  const answers = ["Never", "Rarely", "Sometimes", "Quite often", "Always"];

  useEffect(() => {
    const mergedData = [
      ...vergenceData,
      ...transformFirebaseDataToTableData(answerData)
    ];

    // Sort the mergedData by the answeredOn field
    const sortedData = mergedData.sort((a, b) => {
      const dateA = moment(a.answeredOn, "MMMM D, YYYY");
      const dateB = moment(b.answeredOn, "MMMM D, YYYY");

      return dateA.isBefore(dateB) ? 1 : dateA.isAfter(dateB) ? -1 : 0;
    });
    // Reorder the id fields
    const reorderedData = sortedData.map((item, index) => {
      return {
        ...item,
        id: index + 1
      };
    });

    setCombinedData(reorderedData);
  }, [vergenceData, answerData]);

  function transformApiDataToTableData(apiData) {
    return apiData.sessions.map((session, index) => {
      const totalValue = session.questions.reduce((acc, q) => acc + q.value, 0);
      const formattedDate = moment(session.created_at).format("MMMM D, YYYY");

      return {
        id: index + 1,
        total: totalValue,
        answeredOn: formattedDate,
        details: session.questions,
        session: session.session
      };
    });
  }
  function transformFirebaseDataToTableData(firebaseData) {
    return firebaseData.map((item, index) => {
      return {
        id: index + 1 + vergenceData.length,
        total: item.Total,
        answeredOn: moment(item.DateOfAnswering.toDate()).format(
          "MMMM D, YYYY"
        ),
        details: item.Answers.map(q => ({
          question: q.Question,
          answer: answers[q.Answer]
        }))
      };
    });
  }

  useEffect(() => {
    if (id) {
      const url = `${process.env.REACT_APP_API_GATEWAY_CLOUDRUN}vergence-tests/results?uuid=${id}`;

      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then(data => {
          if (data) {
            const tableData = transformApiDataToTableData(data);
            setVergenceData(tableData);
          } else {
            setVergenceData([]);
          }
        })
        .catch(error => {
          console.error(
            "There was a problem with the fetch operation:",
            error.message
          );
        });
    }
  }, [id]);

  const toggleTab = index => {
    setToggleState(index);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    checkStudentAssignedOrNot();
  }, []);

  useEffect(() => {
    if (studentIds.length > 0) {
      if (studentIds.some(item => item.id === id)) {
        getUserData();
        getUserState();
      } else {
        history.goBack();
      }
    }
  }, [studentIds]);

  const checkStudentAssignedOrNot = async () => {
    const docRef = doc(db, "SubAdminData", currentUser.uid);
    const adminSnapData = await getDoc(docRef);
    if (adminSnapData.exists()) {
      setStudentIds(
        adminSnapData.data().AssignedUsers
          ? adminSnapData.data().AssignedUsers
          : []
      );
    }
  };

  const getUserData = async () => {
    const docRef = doc(db, "UserData", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      docSnap.data().Guardian && getGuardianData(docSnap.data().Guardian.id);
      setUser(docSnap.data());
      setMovementSpeed(docSnap.data().MovementSpeed);
      setPersonalOffset(docSnap.data().PersonalOffset);
      setReadCalibrationFromBackend(docSnap.data().ReadCalibrationFromBackend);
      setRecommendedSessionsPerWeek(docSnap.data().RecommendedSessionsPerWeek);
      setMobileNumber(docSnap.data().MobileNumber);
      setOffsetValue(
        docSnap.data().CalibrationBackend &&
          docSnap.data().CalibrationBackend.offsetValue
      );
      setPendlumLength(
        docSnap.data().CalibrationBackend &&
          docSnap.data().CalibrationBackend.pendlumLength
      );
      setAge(docSnap.data().Age);
      setVROffset(docSnap.data().VROffset ? docSnap.data().VROffset : "");
      setDeviceData(
        docSnap.data().DeviceInfo
          ? docSnap.data().DeviceInfo
          : intialDeviceState
      );
      docSnap.data().ValidTill &&
        setValidTill(
          moment(
            docSnap
              .data()
              .ValidTill.toDate()
              .toDateString()
          )
        );
      docSnap.data().UserAnswers &&
        getUserAnswerData(docSnap.data().UserAnswers);
      docSnap.data().ReadingSpeed &&
        getUserReadingSpeedData(docSnap.data().ReadingSpeed);
      // Initialize the function 'getUserReadingTestsResults' in Google Cloud Functions
      const getUserResults = httpsCallable(
        cloudFunctions,
        "getUserReadingTestsResults"
      );

      // Send a request to the function, passing the user's email as a parameter
      getUserResults({ email: docSnap.data().Email })
        .then(response => {
          // Update the state 'ReadingTestsScores' with the data returned from the function
          setReadingTestsScores(response.data);
        })
        .catch(error => {
          console.log("Error fetching user results", error);
        });
    } else {
      console.log("No such document!");
    }
  };

  // const modifyingUserDataCustom = async (userSnapshotData, uid) => {
  //   try {

  //     //for reading speed recovery

  //     // if (userSnapshotData.ReadingSpeed.length==0) {
  //     //   const userRef = doc(db, "UserData", uid);
  //     //   const docSnap = await updateDoc(userRef, {
  //     //     ReadingSpeed: []
  //     //   });

  //     //   const q = query(collection(db, "ReadingSpeed"), where("User", "==", userRef));
  //     //   const querySnapshot = await getDocs(q);
  //     //   if (querySnapshot.docs.length > 0) {
  //     //     const sortedDocs = querySnapshot.docs.sort(
  //     //       (a, b) =>
  //     //         (a.data().RecordedAtTime.seconds || 0) -
  //     //         (b.data().RecordedAtTime.seconds || 0),
  //     //     );
  //     //     const readingSpeedDoc = sortedDocs.map(
  //     //       (sortedDoc) => sortedDoc.ref,
  //     //     );
  //     //     console.log('abc',sortedDocs)
  //     //     const docSnap = await updateDoc(userRef, {
  //     //     ReadingSpeed: readingSpeedDoc
  //     //   });
  //     //   console.log('updated', docSnap)
  //     //   }
  //     // }

  //     //for User answers recovery

  //     // if (userSnapshotData.UserAnswers.length == 0) {
  //     //   const userRef = doc(db, "UserData", uid);
  //     //   const docSnapData = await updateDoc(userRef, {
  //     //     UserAnswers: []
  //     //   });

  //     //   const q = query(collection(db, "UserAnswers"), where("User", "==", userRef));
  //     //   const querySnapshot = await getDocs(q);
  //     //   if (querySnapshot.docs.length > 0) {
  //     //     const sortedDocs = querySnapshot.docs.sort(
  //     //       (a, b) =>
  //     //         (a.data().DateOfAnswering.seconds || 0) -
  //     //         (b.data().DateOfAnswering.seconds || 0),
  //     //     );
  //     //     const userAnswersDoc = sortedDocs.map(
  //     //       (sortedDoc) => sortedDoc.ref,
  //     //     );
  //     //     const docSnap = await updateDoc(userRef, {
  //     //       UserAnswers: userAnswersDoc
  //     //     });
  //     //     console.log('updated', docSnap)
  //     //   }
  //     // }

  //     //for calibrate result recovery

  //     // if (!userSnapshotData.CalibrateResult) {
  //     //   const userRef = doc(db, "UserData", uid);
  //     //   const docSnapData = await updateDoc(userRef, {
  //     //     CalibrateResult: null
  //     //   });

  //     //   const q = query(collection(db, "CalibrateResult"), where("User", "==", userRef));
  //     //   const querySnapshot = await getDocs(q);
  //     //   if (querySnapshot.docs.length > 0) {
  //     //     const sortedDocs = querySnapshot.docs.sort(
  //     //       (a, b) =>
  //     //         (a.data().CalibratedOnDate.seconds || 0) -
  //     //         (b.data().CalibratedOnDate.seconds || 0),
  //     //     );
  //     //     const docSnap = await updateDoc(userRef, {
  //     //       CalibrateResult: sortedDocs[sortedDocs.length - 1].ref
  //     //     });
  //     //     console.log('updated', sortedDocs[sortedDocs.length - 1].ref)
  //     //   }
  //     // }

  //     //for prev clabration result recovery

  //     // if (userSnapshotData.PrevCalibrationResult.length == 0) {
  //     //   const userRef = doc(db, "UserData", uid);
  //     //   const docSnapData = await updateDoc(userRef, {
  //     //     PrevCalibrationResult: []
  //     //   });

  //     //   const q = query(collection(db, "CalibrateResult"), where("User", "==", userRef));
  //     //   const querySnapshot = await getDocs(q);
  //     //   if (querySnapshot.docs.length > 0) {
  //     //     const sortedDocs = querySnapshot.docs.sort(
  //     //       (a, b) =>
  //     //         (a.data().CalibratedOnDate.seconds || 0) -
  //     //         (b.data().CalibratedOnDate.seconds || 0),
  //     //     );
  //     //     sortedDocs.pop();
  //     //     const prevCalibrationDoc = sortedDocs.map(
  //     //       (sortedDoc) => sortedDoc.ref,
  //     //     );

  //     //     const docSnap = await updateDoc(userRef, {
  //     //       PrevCalibrationResult: prevCalibrationDoc
  //     //     });
  //     //     console.log('updated', prevCalibrationDoc)
  //     //   }
  //     // }
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const getUserState = async () => {
    axios.get(BASE_URL.REACT_APP_API_URL + `/admin/getUser/${id}`).then(res => {
      setUserAuthData(res.data.data);
      // setActiveInactive(res.data.data.disabled);
    });
  };

  const getGuardianData = async GuardianId => {
    const docRef = doc(db, "Guardian", GuardianId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setGuardian(docSnap.data());
    } else {
      console.log("No such document!");
    }
  };

  // const UpdateStatus = () => {
  //   let data = { user_uid: id, disabled: activeInactive ? false : true };
  //   axios
  //     .put(BASE_URL.REACT_APP_API_URL + `/admin/disableUser`, data)
  //     .then(res => {
  //       getUserState();
  //     });
  // };

  const UpdateUserDetails = async () => {
    const washingtonRef = doc(db, "UserData", id);
    await updateDoc(washingtonRef, {
      MobileNumber: MobileNumber,
      Age: Age,
      ValidTill: new Date(ValidTill)
    });
    setUserDetailsEdit(false);
    getUserData();
  };

  const UpdateOtherDetails = async () => {
    const washingtonRef = doc(db, "UserData", id);
    await updateDoc(washingtonRef, {
      MovementSpeed: parseFloat(MovementSpeed),
      PersonalOffset: parseFloat(PersonalOffset),
      ReadCalibrationFromBackend: ReadCalibrationFromBackend,
      RecommendedSessionsPerWeek: RecommendedSessionsPerWeek,
      CalibrationBackend: {
        offsetValue: parseFloat(offsetValue),
        pendlumLength: parseFloat(pendlumLength)
      },
      VROffset: parseFloat(vrOffset)
    });
    setOtherDetailsEdit(false);
    getUserData();
  };

  // const [open, setopen] = useState(false)
  // const statusDropdoen = () => {
  //   setopen(!open)
  // }

  const getUserAnswerData = async ids => {
    let answerIds = [];
    if (ids.length > 0) {
      ids.forEach(item => {
        answerIds.push(item.id);
      });
    }
    if (answerIds.length > 0) {
      const answerRef = collection(db, "UserAnswers");
      const answersDocSnap = query(
        answerRef,
        where(documentId(), "in", answerIds)
      );
      let answerDocs = await getDocs(answersDocSnap);
      let answersData = answerDocs.docs;
      answersData.sort((a, b) => {
        return (
          new Date(a.data().DateOfAnswering.toDate()) -
          new Date(b.data().DateOfAnswering.toDate())
        );
      });
      answersData.forEach(answerDoc => {
        setAnswerData(prevData => [
          ...prevData,
          { id: answerDoc.id, ...answerDoc.data() }
        ]);
      });
    }
  };

  const answerModal = index => {
    setAnswerModalVisible(!answer_modal_visible);
    setAnswerModalData(null);
    if (index !== undefined) {
      setAnswerModalData(answerData[index]);
    }
  };

  const getAnswer = id => {
    return answers[id];
  };

  const getUserReadingSpeedData = async ids => {
    let readSpeedIds = [];
    if (ids.length > 0) {
      ids.forEach(item => {
        readSpeedIds.push(item.id);
      });
    }
    if (readSpeedIds.length > 0) {
      const readingSpeedRef = collection(db, "ReadingSpeed");
      const readingSpeedDocSnap = query(
        readingSpeedRef,
        where(documentId(), "in", readSpeedIds)
      );
      const readingSpeedDocs = await getDocs(readingSpeedDocSnap);
      let readingSpeedData = readingSpeedDocs.docs;
      readingSpeedData.sort((a, b) => {
        return (
          new Date(a.data().RecordedAtTime.toDate()) -
          new Date(b.data().RecordedAtTime.toDate())
        );
      });
      readingSpeedData.forEach(readingSpeedDoc => {
        setReadingSpeedData(prevData => [
          ...prevData,
          { id: readingSpeedDoc.id, ...readingSpeedDoc.data() }
        ]);
      });
    }
  };

  const nth = n => {
    return ["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th";
  };

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <div className="bloc-tabs">
        <button
          className={toggleState === 1 ? "tabs active-tabs" : "tabs"}
          onClick={() => toggleTab(1)}
        >
          User Details
        </button>
        <button
          className={toggleState === 2 ? "tabs active-tabs" : "tabs"}
          onClick={() => toggleTab(2)}
        >
          Calibration
        </button>
        <button
          className={toggleState === 3 ? "tabs active-tabs" : "tabs"}
          onClick={() => toggleTab(3)}
        >
          Training Result
        </button>
      </div>

      <div className="content-tabs">
        <div
          className={toggleState === 1 ? "content  active-content" : "content"}
        >
          {user === "" ? (
            <div className="wrapper">
              <div className="spinner">
                <div className="spinner-1"></div>
                <div className="spinner-2"></div>
                <div className="spinner-3"></div>
              </div>
            </div>
          ) : (
            <div>
              <Row>
                <Col lg="12" md="12" sm="12">
                  <Card small className="mb-4 pt-4">
                    <CardHeader className="border-bottom">
                      <div
                        className="d-flex"
                        style={{ justifyContent: "space-between" }}
                      >
                        <div>
                          <h4 className="mb-0 pl-2">
                            {user.FirstName + " " + user.LastName}
                          </h4>
                          <span className="text-muted d-block mb-2">
                            {user.Email}
                          </span>
                        </div>
                        {/* <h6>
                          {userDetailsEdit == false ? (
                            <span
                              className="material-icons"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setUserDetailsEdit(!userDetailsEdit)
                              }
                            >
                              edit
                            </span>
                          ) : (
                            <span
                              className="material-icons"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setUserDetailsEdit(!userDetailsEdit)
                              }
                            >
                              close
                            </span>
                          )}
                        </h6> */}
                      </div>
                    </CardHeader>
                    {!userDetailsEdit ? (
                      <Row>
                        <Col sm="12" md="6" lg="6">
                          <ListGroup flush>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper d-flex">
                                <strong className="text-muted d-block mb-2">
                                  Status :{" "}
                                  {userAuthData.disabled === true
                                    ? "InActive"
                                    : "Active"}
                                </strong>
                                {/* <div style={{ marginLeft: 30 }}>
                                  <Dropdown
                                    open={open}
                                    size="sm"
                                    className="mr-2"
                                    toggle={() => statusDropdoen()}
                                  >
                                    <DropdownToggle className="dropdown-aa">
                                      <span className="material-icons"
                                      >
                                        edit
                                      </span></DropdownToggle>
                                    <DropdownMenu>
                                      <DropdownItem onClick={() => UpdateStatus()}>
                                        {userAuthData.disabled ? 'Enable' : 'Disable'}
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </Dropdown>
                                </div> */}
                              </div>
                            </ListGroupItem>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper">
                                <strong className="text-muted d-block mb-2">
                                  Mobile Number : {user.MobileNumber}
                                </strong>
                              </div>
                            </ListGroupItem>
                            <ListGroupItem className="p-4">
                              <strong className="text-muted d-block mb-2">
                                Age : {user.Age}
                              </strong>
                            </ListGroupItem>
                          </ListGroup>
                        </Col>
                        <Col sm="12" md="6" lg="6">
                          <ListGroup flush>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper">
                                <strong className="text-muted d-block mb-2">
                                  Registered At :{" "}
                                  {user.RegisteredOn &&
                                    user.RegisteredOn.toDate().toDateString()}
                                </strong>
                              </div>
                            </ListGroupItem>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper">
                                <strong className="text-muted d-block mb-2">
                                  ValidTill :{" "}
                                  {user.ValidTill &&
                                    moment(
                                      user.ValidTill.toDate().toDateString()
                                    ).format("LL")}
                                </strong>
                              </div>
                            </ListGroupItem>
                            <ListGroupItem className="p-4">
                              <strong className="text-muted d-block mb-2">
                                Last Session Done At :{" "}
                                {user.LastSessionDoneAt &&
                                  moment(
                                    user.LastSessionDoneAt.toDate().toString()
                                  ).format("lll")}
                              </strong>
                            </ListGroupItem>
                          </ListGroup>
                        </Col>
                        <Col sm="12" md="6" lg="6">
                          <ListGroup flush>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper">
                                <strong className="text-muted d-block mb-2">
                                  User Type :{" "}
                                  {user.UserType ? user.UserType : "-"}
                                </strong>
                              </div>
                            </ListGroupItem>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper">
                                <strong className="text-muted d-block mb-2">
                                  Program Subscription Status :{" "}
                                  {user.UserType
                                    ? user.UserType === "Training"
                                      ? "True"
                                      : "False"
                                    : "False"}
                                </strong>
                              </div>
                            </ListGroupItem>
                          </ListGroup>
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col>
                          <ListGroup flush>
                            <ListGroupItem className="px-4">
                              <Form>
                                <FormGroup>
                                  <label htmlFor="#MobileNumber">
                                    Mobile Number
                                  </label>
                                  <FormInput
                                    id="#MobileNumber"
                                    placeholder="Mobile Number"
                                    type="number"
                                    value={MobileNumber}
                                    onChange={e =>
                                      setMobileNumber(e.target.value)
                                    }
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <label htmlFor="#Age">Age</label>
                                  <FormInput
                                    id="#Age"
                                    placeholder="Age"
                                    type="number"
                                    value={Age}
                                    onChange={e => setAge(e.target.value)}
                                  />
                                </FormGroup>
                                <div className="form-group">
                                  <label>Valid Till</label>
                                  <br />
                                  <DatePicker
                                    wrapperClassName="datePicker"
                                    selected={new Date(ValidTill)}
                                    onChange={date => setValidTill(date)}
                                  />
                                </div>
                                <div className="d-flex w-70">
                                  <Button
                                    theme="secondary"
                                    className="submit_button"
                                    onClick={() =>
                                      setUserDetailsEdit(!userDetailsEdit)
                                    }
                                  >
                                    Close
                                  </Button>
                                  <Button
                                    theme="success"
                                    className="submit_button"
                                    onClick={() => UpdateUserDetails()}
                                  >
                                    Submit
                                  </Button>
                                </div>
                              </Form>
                            </ListGroupItem>
                          </ListGroup>
                        </Col>
                      </Row>
                    )}
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col md="6" sm="12">
                  <Card small className="mb-4 pt-4">
                    <CardHeader className="border-bottom">
                      <h4 className="mb-0">Guardian Details</h4>
                    </CardHeader>
                    <ListGroup flush>
                      <ListGroupItem className="px-4">
                        <div className="progress-wrapper">
                          <strong className="text-muted d-block mb-1">
                            Name :{" "}
                            {guardian
                              ? guardian.Name
                                ? guardian.Name
                                : "-"
                              : "-"}
                          </strong>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="px-4">
                        <div className="progress-wrapper">
                          <strong className="text-muted d-block mb-1">
                            Email :{" "}
                            {guardian
                              ? guardian.Email
                                ? guardian.Email
                                : "-"
                              : "-"}
                          </strong>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="p-4">
                        <strong className="text-muted d-block mb-1">
                          Mobile Number :{" "}
                          {guardian
                            ? guardian.MobileNumber
                              ? guardian.MobileNumber
                              : "-"
                            : "-"}
                        </strong>
                      </ListGroupItem>
                    </ListGroup>
                  </Card>
                </Col>
                <Col md="6" sm="12">
                  <Card small className="mb-4 pt-4">
                    <CardHeader className="border-bottom">
                      <div
                        className="d-flex"
                        style={{ justifyContent: "space-between" }}
                      >
                        <h4 className="mb-0">Other Details</h4>
                        {/* <h6>
                          <span
                            className="material-icons"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setOtherDetailsEdit(!otherDetailsEdit)
                            }
                          >
                            edit
                          </span>
                        </h6> */}
                      </div>
                    </CardHeader>
                    {!otherDetailsEdit ? (
                      <ListGroup flush>
                        <ListGroupItem className="px-4">
                          <div className="progress-wrapper">
                            <strong className="text-muted d-block">
                              Movement Speed : {user.MovementSpeed}
                            </strong>
                          </div>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <div className="progress-wrapper">
                            <strong className="text-muted d-block">
                              Personal Offset : {user.PersonalOffset}
                            </strong>
                          </div>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <strong className="text-muted d-block">
                            Read Calibration From Backend :{" "}
                            {user.ReadCalibrationFromBackend ? "Yes" : "No"}
                          </strong>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <strong className="text-muted d-block">
                            Offset Value :{" "}
                            {user.CalibrationBackend
                              ? user.CalibrationBackend.offsetValue
                              : "-"}
                          </strong>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <strong className="text-muted d-block">
                            Pendlum Length :{" "}
                            {user.CalibrationBackend
                              ? user.CalibrationBackend.pendlumLength
                              : "-"}
                          </strong>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <strong className="text-muted d-block">
                            Recommended Sessions Per Week :{" "}
                            {user.RecommendedSessionsPerWeek}
                          </strong>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <strong className="text-muted d-block">
                            VR Offset : {user.VROffset ? user.VROffset : "-"}
                          </strong>
                        </ListGroupItem>
                      </ListGroup>
                    ) : (
                      <ListGroup flush>
                        <ListGroupItem className="px-4">
                          <Form>
                            <FormGroup>
                              <label htmlFor="#MovementSpeed">
                                Movement Speed
                              </label>
                              <FormInput
                                id="#MovementSpeed"
                                placeholder="Movement Speed"
                                type="number"
                                value={MovementSpeed}
                                onChange={e => setMovementSpeed(e.target.value)}
                              />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#PersonalOffset">
                                Personal Offset
                              </label>
                              <FormInput
                                id="#PersonalOffset"
                                placeholder="Personal Offset"
                                type="number"
                                value={PersonalOffset}
                                onChange={e =>
                                  setPersonalOffset(e.target.value)
                                }
                              />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#ReadCalibrationFromBackend">
                                Read Calibration From Backend
                              </label>
                              <FormSelect
                                value={ReadCalibrationFromBackend}
                                onChange={e => {
                                  if (e.target.value === "true") {
                                    setReadCalibrationFromBackend(true);
                                  } else {
                                    setReadCalibrationFromBackend(false);
                                  }
                                }}
                              >
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </FormSelect>
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#OffSetValue">Offset Value</label>
                              <FormInput
                                id="#OffSetValue"
                                value={offsetValue}
                                type="number"
                                placeholder="Offset Value"
                                onChange={e => setOffsetValue(e.target.value)}
                              />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#PendlumLength">
                                Pendlum Length
                              </label>
                              <FormInput
                                id="#PendlumLength"
                                value={pendlumLength}
                                type="number"
                                placeholder="Pendlum Length"
                                onChange={e => setPendlumLength(e.target.value)}
                              />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#RecommendedSessionsPerWeek">
                                Recommended Sessions Per Week
                              </label>
                              <FormInput
                                id="#RecommendedSessionsPerWeek"
                                value={RecommendedSessionsPerWeek}
                                type="number"
                                placeholder="Recommended Sessions Per Week"
                                onChange={e =>
                                  setRecommendedSessionsPerWeek(e.target.value)
                                }
                              />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#VROffset">VR Offset</label>
                              <FormInput
                                id="#VROffset"
                                value={vrOffset}
                                type="number"
                                placeholder="VR Offset"
                                onChange={e => setVROffset(e.target.value)}
                              />
                            </FormGroup>
                            <div className="d-flex">
                              <Button
                                theme="secondary"
                                className="submit_button"
                                onClick={() =>
                                  setOtherDetailsEdit(!otherDetailsEdit)
                                }
                              >
                                Close
                              </Button>
                              <Button
                                theme="success"
                                className="submit_button"
                                onClick={() => UpdateOtherDetails()}
                              >
                                Submit
                              </Button>
                            </div>
                          </Form>
                        </ListGroupItem>
                      </ListGroup>
                    )}
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <Card small className="mb-4">
                    <CardHeader className="border-bottom">
                      Vergence Test
                    </CardHeader>
                    <CardBody>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          height: 350,
                          width: "100%",
                          "& .actions": {
                            color: "text.secondary"
                          },
                          "& .textPrimary": {
                            color: "text.primary"
                          }
                        }}
                      >
                        <VergenceTestsGrid data={combinedData} />
                      </Box>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="6">
                  <Card small className="mb-4">
                    <CardHeader className="border-bottom">
                      Reading Speed Score
                    </CardHeader>
                    <CardBody>
                      <FullFeaturedCrudGrid
                        data={readingSpeedData}
                        userId={id}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <Card small className="mb-4">
                    <CardHeader className="border-bottom">
                      Proprietary Reading Speed Score
                    </CardHeader>
                    <CardBody>
                      <ProprietaryTestsGrid
                        data={readingTestsScores}
                        email={user.Email}
                      />
                    </CardBody>
                  </Card>
                </Col>

                <Col md="6">
                  <Card small className="mb-4">
                    <CardHeader className="border-bottom">
                      Mobile Details
                    </CardHeader>
                    <CardBody>
                      <p>
                        Resolution :{" "}
                        {user.CalibrationBackend
                          ? user.CalibrationBackend.deviceDimensions
                            ? user.CalibrationBackend.deviceDimensions.width
                              ? user.CalibrationBackend.deviceDimensions.width *
                                  user.CalibrationBackend.deviceDimensions
                                    .pixelRatio +
                                " x " +
                                user.CalibrationBackend.deviceDimensions
                                  .height *
                                  user.CalibrationBackend.deviceDimensions
                                    .pixelRatio
                              : "-"
                            : "-"
                          : "-"}
                      </p>
                      <p>
                        Mobile:{" "}
                        {deviceData.manufacturer + " " + deviceData.model}
                      </p>
                      <p>OS : {deviceData.os && deviceData.os}</p>
                      <p>
                        OS Version:{" "}
                        {deviceData.osversion && deviceData.osversion}
                      </p>
                      <p>
                        App Version : {deviceData.version && deviceData.version}
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          )}
        </div>
        <div
          className={toggleState === 2 ? "content  active-content" : "content"}
        >
          <Row>
            <Col>{user && <Calibration userdata={user} />}</Col>
          </Row>
        </div>

        <div
          className={toggleState === 3 ? "content active-content" : "content"}
        >
          <Row>
            <Col>{user && <TrainingResult userdata={user} />}</Col>
          </Row>
        </div>
      </div>

      <Modal open={answer_modal_visible} toggle={answerModal}>
        <ModalHeader>Answers</ModalHeader>
        <ModalBody className="answer_modal">
          {answer_modal_data
            ? answer_modal_data.Answers.map((q, i) => {
                return (
                  <div key={i} className="pb-4">
                    <span className="pb-1 d-block">
                      {i + 1 + ". " + q.Question}
                    </span>
                    <span>Answer : {getAnswer(q.Answer)}</span>
                  </div>
                );
              })
            : null}
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default StudentDetails;
